// constants
import { AuthActionTypes } from './constants';

export interface AuthActionType {
    type:
    | AuthActionTypes.API_RESPONSE_SUCCESS
    | AuthActionTypes.API_RESPONSE_ERROR
    | AuthActionTypes.FORGOT_PASSWORD
    | AuthActionTypes.FORGOT_PASSWORD_CHANGE
    | AuthActionTypes.LOGIN_USER
    | AuthActionTypes.LOGOUT_USER
    |AuthActionTypes.LOGIN_USER_WITH_CODE
    | AuthActionTypes.RESET
    | AuthActionTypes.LOGIN_USER_WITH_SSO
    | AuthActionTypes.SIGNUP_USER;
    payload: {} | string;
}



interface UserData {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: string;
}

// common success
export const authApiResponseSuccess = (actionType: string, data: UserData | {}, details?: any): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, details },
});
// common error
export const authApiResponseError = (actionType: string, error: string, errorStatus?: string): AuthActionType => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error, errorStatus },
});

export const loginUser = (email: string, password: string): AuthActionType => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { email, password },
});

export const loginUserWithCode = (email: string, password: string, code: string): AuthActionType => ({
    type: AuthActionTypes.LOGIN_USER_WITH_CODE,
    payload: { email, password, code },
});

export const logoutUser = (): AuthActionType => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const signupUser = (fullname: string, email: string, password: string): AuthActionType => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { fullname, email, password },
});

export const forgotPassword = (email: string): AuthActionType => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { email },
});

export const resetAuth = (): AuthActionType => ({
    type: AuthActionTypes.RESET,
    payload: {},
});

export const loginUserWithSso = (token: string): AuthActionType => ({
    type: AuthActionTypes.LOGIN_USER_WITH_SSO,
    payload: { token },
});
